import Header from "../components/Header";
import Hero from "../components/Hero";
import SocialProofBar from "../components/SocialProofBar";
import About from "../components/About";
import HowItWorks from "../components/HowItWorks";
import Stats from "../components/Stats";
import StatesCovered from "../components/StatesCovered";
import ClaimForm from "../components/ClaimForm";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#FDFBF7]" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <SocialProofBar />
        <About />
        <HowItWorks />
        <Stats />
        <StatesCovered />
        <ClaimForm />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
